import { getAPM } from '@interhyp/platform-apm';
import { getAPIPath } from '@interhyp/platform-request';
import fetchWrapper, { getConnection } from '@interhyp/util-request';

import { Intent, IntentOld } from '../interfaces/Intent';

export const getListOfIntents = async (
  userId?: string,
  preventReCheck = false,
): Promise<IntentOld[]> => {
  try {
    const res = await fetchWrapper(
      getConnection(),
      `${getAPIPath('advisory-excellence-portal')}/home/api/customers/intent/v1/intents`,
    );
    // check response
    if (res.status === 200) {
      const data = await res.json();

      try {
        if (!preventReCheck && sessionStorage.getItem('INTERIM_RE_CHECK_INTENTS') !== 'true') {
          sessionStorage.setItem('INTERIM_RE_CHECK_INTENTS', 'true');
          void reCheckIntents(data, userId);
        }
      } catch {}

      return data;
    }
    return [];
  } catch {
    return [];
  }
};

export const getIntentFromIntentServiceById = async (
  intentId: string | undefined,
): Promise<Intent | null> => {
  try {
    const res = await fetchWrapper(
      getConnection(),
      `${getAPIPath('intent')}/api/v1/intents/${intentId}`,
    );

    if (res.ok) {
      return res.json();
    }

    return null;
  } catch {
    return null;
  }
};

export const getIntentFromAdvisoryBffById = async (intentId?: string): Promise<Intent | null> => {
  if (!intentId) {
    return null;
  }

  try {
    const res = await fetchWrapper(
      getConnection(),
      `${getAPIPath(
        'advisory-excellence-portal',
      )}/home/api/customers/intent/v1/intents/${intentId}`,
      { method: 'GET' },
    );

    if (res.status === 200) {
      return res.json();
    }

    return null;
  } catch {
    return null;
  }
};

const reCheckTimeouts = [10_000, 10_000, 60_000, 120_000, 60_000 * 15];

async function reCheckIntents(
  prevList: IntentOld[],
  userId?: string,
  startTime = Date.now(),
  counter = 0,
): Promise<void> {
  if (!Array.isArray(prevList)) {
    return;
  }

  // Wait Xms
  await new Promise(resolve => {
    setTimeout(resolve, reCheckTimeouts[counter] ?? reCheckTimeouts[0]);
  });
  const timeDelta = Date.now() - startTime;
  const currentList = await getListOfIntents(userId, true);

  // Get all elements which are not in the prev list
  const diffList = currentList.filter(
    currentElement => !prevList.some(oldElement => oldElement.intentId === currentElement.intentId),
  );

  if (diffList.length > 0) {
    const apm = getAPM();
    apm.captureError(
      new Error(
        `INTENT_LIST_DIFFERENCE
Old list length: ${prevList.length}
New list length: ${currentList.length}
New elements: ${diffList.length}
Intent-ID(s): [${diffList.map(({ intentId }) => intentId).join(',')}]
Time delta: ${timeDelta}ms
User ID: ${userId}`,
      ),
    );
    return;
  }

  if (counter < reCheckTimeouts.length - 1) {
    await reCheckIntents(prevList, userId, startTime, counter + 1);
  }
}
